import { getApiUrl } from '../../util/api/api'
import type { Filters } from '../../../state/reducers/jobs/jobs'

const validStatusesMap = {
  draft: '',
  validdraft: '',
  submitted: '',
  rejected: '',
  approved: '',
  published: '',
  suspended: '',
  expired: '',
  multistepdraft: '',
}

export type JobStatus = keyof typeof validStatusesMap

export type JobFilterAmounts = Record<JobStatus, number>

const validStatuses = Object.keys(validStatusesMap) as Array<JobStatus>
export const isValidStatus = (status: JobStatus) => validStatuses.includes(status)

// removes 'validdraft' as key from amounts and combines the value with 'draft'
const jobStatusFiltersResultFunc = (filterAmounts: JobFilterAmounts): Filters => {
  const copiedFilters: JobFilterAmounts = { ...filterAmounts }
  const combinedDraftCount = (copiedFilters.draft || 0) + (copiedFilters.validdraft || 0)
  if (combinedDraftCount > 0) copiedFilters.draft = combinedDraftCount
  delete copiedFilters.validdraft

  const filters = Object.keys(copiedFilters).map((name: JobStatus) => {
    const count = copiedFilters[name]
    return { name, count }
  })

  // make sure "rejected" filter always goes last
  filters.splice(
    filters.length - 1,
    0,
    ...filters.splice(
      filters.findIndex(({ name }) => name === 'rejected'),
      1,
    ),
  )
  return filters
}

const fetchJobs = async (page: number, status?: string, query?: string, itemsPerPage: number = 15) => {
  const params: any = {
    page,
    itemsPerPage,
    search: (query?.length || 0) > 2 ? query : '',
  }

  if (status) {
    params.status = status.indexOf('draft') > -1 ? `${status},validdraft` : status
  }

  const fetchResponse = await fetch(
      `${getApiUrl('/api/v1/job')}?${new URLSearchParams(params)}`, {
        headers: {
          'Content-Type': 'application/json',
        },
        mode: 'cors',
        credentials: 'include',
      }
    )
  
  if (fetchResponse?.ok) {
    const responseJson = await fetchResponse.json()
    return Promise.resolve({
      status: fetchResponse.status,
      data: {
        ...responseJson,
        amounts: jobStatusFiltersResultFunc(responseJson.amounts),
      },
    })
  } else {
    throw new Error(`Error while fetching jobs: ${fetchResponse?.statusText || '(no info)'}`)
  }
}
export default fetchJobs
